const initialState = { 
    isLoggedIn: false, 
    userid: 0,
    username: null, 
    token: null, 
    firstName: null, 
    lastName: null, 
}


const loginReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'RETRIEVE_TOKEN': //Check if user has previously logged into the app (check localstorage or cookie)
            return {
                ...state,
                userid: action.userid, 
                username: action.username, //username required upon re-login via localstorage, as you will need to do RBAC later
                token: action.token,
                isLoggedIn: action.isLoggedIn, 
                firstName: action.firstName,
                lastName: action.lastName, 
            };
        case 'LOGIN': 
            return {
                ...state,
                userid: action.userid, 
                username: action.username, 
                token: action.token, 
                isLoggedIn: true, 
                firstName: action.firstName,
                lastName: action.lastName, 
            };
        case 'LOGOUT': 
            return {
                ...state,
                userid: null, 
                username: null, 
                token: null, 
                isLoggedIn: false,
                firstName: null,
                lastName: null
            };
        case 'REGISTER': 
            return {
                ...state,
                userid: action.userid, 
                username: action.username, 
                token: action.token, 
                isLoggedIn: false, 
                firstName: action.firstName,
                lastName: action.lastName, 
            };
        default: 
            return state;
    }
};

export default loginReducer;
